"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Builder = void 0;
exports.declare = declare;
exports.bool = bool;
exports.integer = integer;
exports.decimal = decimal;
exports.float = float;
exports.double = double;
exports.string = string;
exports.langString = langString;
exports.dirLangString = dirLangString;
exports.dateTime = dateTime;
exports.expressionToVar = expressionToVar;
/**
 * These helpers provide a (albeit inflexible) DSL for writing function
 * definitions for the SPARQL functions.
 */
const context_entries_1 = require("@comunica/context-entries");
const E = __importStar(require("../expressions"));
const expressions_1 = require("../expressions");
const C = __importStar(require("../util/Consts"));
const Consts_1 = require("../util/Consts");
const Err = __importStar(require("../util/Errors"));
const Errors_1 = require("../util/Errors");
const OverloadTree_1 = require("./OverloadTree");
function declare(identifier) {
    return new Builder(identifier);
}
class Builder {
    overloadTree;
    collected;
    constructor(identifier) {
        this.overloadTree = new OverloadTree_1.OverloadTree(identifier);
        this.collected = false;
    }
    collect() {
        if (this.collected) {
            // Only 1 time allowed because we can't copy a tree. (And we don't need this).
            throw new Error('Builders can only be collected once!');
        }
        this.collected = true;
        return this.overloadTree;
    }
    static wrapInvalidLexicalProtected(func) {
        return (expressionEvaluator) => (args) => {
            for (const [index, arg] of args.entries()) {
                if (arg instanceof expressions_1.NonLexicalLiteral) {
                    throw new Err.InvalidLexicalForm(args[index].toRDF(expressionEvaluator.context.getSafe(context_entries_1.KeysInitQuery.dataFactory)));
                }
            }
            return func(expressionEvaluator)(args);
        };
    }
    set(argTypes, func, addInvalidHandling = true) {
        this.overloadTree.addOverload(argTypes, addInvalidHandling ? Builder.wrapInvalidLexicalProtected(func) : func);
        return this;
    }
    copy({ from, to }) {
        const impl = this.overloadTree.getImplementationExact(from);
        if (!impl) {
            throw new Err.UnexpectedError('Tried to copy implementation, but types not found', { from, to });
        }
        return this.set(to, impl);
    }
    onUnary(type, op, addInvalidHandling = true) {
        return this.set([type], expressionEvaluator => ([val]) => op(expressionEvaluator)(val), addInvalidHandling);
    }
    onUnaryTyped(type, op, addInvalidHandling = true) {
        return this.set([type], expressionEvaluator => ([val]) => op(expressionEvaluator)(val.typedValue), addInvalidHandling);
    }
    onBinary(types, op, addInvalidHandling = true) {
        return this.set(types, expressionEvaluator => ([left, right]) => op(expressionEvaluator)(left, right), addInvalidHandling);
    }
    onBinaryTyped(types, op, addInvalidHandling = true) {
        return this.set(types, expressionEvaluator => ([left, right]) => op(expressionEvaluator)(left.typedValue, right.typedValue), addInvalidHandling);
    }
    onTernaryTyped(types, op, addInvalidHandling = true) {
        return this.set(types, expressionEvaluator => ([a1, a2, a3]) => op(expressionEvaluator)(a1.typedValue, a2.typedValue, a3.typedValue), addInvalidHandling);
    }
    onTernary(types, op, addInvalidHandling = true) {
        return this.set(types, expressionEvaluator => ([a1, a2, a3]) => op(expressionEvaluator)(a1, a2, a3), addInvalidHandling);
    }
    onQuaternaryTyped(types, op, addInvalidHandling = true) {
        return this.set(types, expressionEvaluator => ([a1, a2, a3, a4]) => op(expressionEvaluator)(a1.typedValue, a2.typedValue, a3.typedValue, a4.typedValue), addInvalidHandling);
    }
    onTerm1(op, addInvalidHandling = false) {
        return this.set(['term'], expressionEvaluator => ([term]) => op(expressionEvaluator)(term), addInvalidHandling);
    }
    onTerm3(op) {
        return this.set(['term', 'term', 'term'], expressionEvaluator => ([t1, t2, t3]) => op(expressionEvaluator)(t1, t2, t3));
    }
    onQuad1(op) {
        return this.set(['quad'], expressionEvaluator => ([term]) => op(expressionEvaluator)(term));
    }
    onLiteral1(op, addInvalidHandling = true) {
        return this.set(['literal'], expressionEvaluator => ([term]) => op(expressionEvaluator)(term), addInvalidHandling);
    }
    onBoolean1(op, addInvalidHandling = true) {
        return this.set([C.TypeURL.XSD_BOOLEAN], expressionEvaluator => ([lit]) => op(expressionEvaluator)(lit), addInvalidHandling);
    }
    onBoolean1Typed(op, addInvalidHandling = true) {
        return this.set([C.TypeURL.XSD_BOOLEAN], expressionEvaluator => ([lit]) => op(expressionEvaluator)(lit.typedValue), addInvalidHandling);
    }
    onString1(op, addInvalidHandling = true) {
        return this.set([C.TypeURL.XSD_STRING], expressionEvaluator => ([lit]) => op(expressionEvaluator)(lit), addInvalidHandling);
    }
    onString1Typed(op, addInvalidHandling = true) {
        return this.set([C.TypeURL.XSD_STRING], expressionEvaluator => ([lit]) => op(expressionEvaluator)(lit.typedValue), addInvalidHandling);
    }
    onLangString1(op, addInvalidHandling = true) {
        return this.set([C.TypeURL.RDF_LANG_STRING], expressionEvaluator => ([lit]) => op(expressionEvaluator)(lit), addInvalidHandling);
    }
    onDirLangString1(op, addInvalidHandling = true) {
        return this.set([C.TypeURL.RDF_DIR_LANG_STRING], expressionEvaluator => ([lit]) => op(expressionEvaluator)(lit), addInvalidHandling);
    }
    onStringly1(op, addInvalidHandling = true) {
        return this.set([C.TypeAlias.SPARQL_STRINGLY], expressionEvaluator => ([lit]) => op(expressionEvaluator)(lit), addInvalidHandling);
    }
    onStringly1Typed(op, addInvalidHandling = true) {
        return this.set([C.TypeAlias.SPARQL_STRINGLY], expressionEvaluator => ([lit]) => op(expressionEvaluator)(lit.typedValue), addInvalidHandling);
    }
    /**
     * https://www.w3.org/TR/sparql12-query/#dfn-argument-compatible
     */
    verifyCompatibility(litA, litB) {
        // The fact that it is stringly means that it is either xsd:string or a subType, or it is langDirStr or LanStr
        const typeA = litA.dataType;
        const typeB = litB.dataType;
        if (typeA === Consts_1.TypeURL.RDF_DIR_LANG_STRING) {
            if (typeB === Consts_1.TypeURL.RDF_LANG_STRING) {
                throw new Errors_1.IncompatibleLanguageOperation(litA, litB);
            }
            if (typeB === Consts_1.TypeURL.RDF_DIR_LANG_STRING &&
                !(litA.language === litB.language && litA.direction === litB.direction)) {
                throw new Errors_1.IncompatibleLanguageOperation(litA, litB);
            }
        }
        else if (typeA === Consts_1.TypeURL.RDF_LANG_STRING) {
            if (typeB === Consts_1.TypeURL.RDF_DIR_LANG_STRING) {
                throw new Errors_1.IncompatibleLanguageOperation(litA, litB);
            }
            if (typeB === Consts_1.TypeURL.RDF_LANG_STRING && litA.language !== litB.language) {
                throw new Errors_1.IncompatibleLanguageOperation(litA, litB);
            }
        }
        // We now know A is an xsd:string derived
        if (typeA === Consts_1.TypeURL.XSD_STRING && (typeB === Consts_1.TypeURL.RDF_DIR_LANG_STRING || typeB === Consts_1.TypeURL.RDF_LANG_STRING)) {
            throw new Errors_1.IncompatibleLanguageOperation(litA, litB);
        }
    }
    onCompatibleStringly2(op, addInvalidHandling = true) {
        return this.set([C.TypeAlias.SPARQL_STRINGLY, C.TypeAlias.SPARQL_STRINGLY], expressionEvaluator => ([litA, litB]) => {
            this.verifyCompatibility(litA, litB);
            return op(expressionEvaluator)(litA, litB);
        }, addInvalidHandling);
    }
    onCompatibleStringly2Typed(op, addInvalidHandling = true) {
        return this.set([C.TypeAlias.SPARQL_STRINGLY, C.TypeAlias.SPARQL_STRINGLY], expressionEvaluator => ([litA, litB]) => {
            this.verifyCompatibility(litA, litB);
            return op(expressionEvaluator)(litA.typedValue, litB.typedValue);
        }, addInvalidHandling);
    }
    onNumeric1(op, addInvalidHandling = true) {
        return this.set([C.TypeAlias.SPARQL_NUMERIC], expressionEvaluator => ([val]) => op(expressionEvaluator)(val), addInvalidHandling);
    }
    onDateTime1(op, addInvalidHandling = true) {
        return this
            .set([C.TypeURL.XSD_DATE_TIME], expressionEvaluator => ([val]) => op(expressionEvaluator)(val), addInvalidHandling);
    }
    /**
     * We return the base types and not the provided types because we don't want to create invalid terms.
     * Providing negative number to a function unary - for example should not
     * return a term of type negative number having a positive value.
     * @param op the numeric operator performed
     * @param addInvalidHandling whether to add invalid handling,
     *   whether to add @param op in @see wrapInvalidLexicalProtected
     */
    numericConverter(op, addInvalidHandling = true) {
        const evalHelper = (expressionEvaluator) => (arg) => op(expressionEvaluator)(arg.typedValue);
        return this.onUnary(Consts_1.TypeURL.XSD_INTEGER, expressionEvaluator => arg => integer(evalHelper(expressionEvaluator)(arg)), addInvalidHandling)
            .onUnary(Consts_1.TypeURL.XSD_DECIMAL, expressionEvaluator => arg => decimal(evalHelper(expressionEvaluator)(arg)), addInvalidHandling)
            .onUnary(Consts_1.TypeURL.XSD_FLOAT, expressionEvaluator => arg => float(evalHelper(expressionEvaluator)(arg)), addInvalidHandling)
            .onUnary(Consts_1.TypeURL.XSD_DOUBLE, expressionEvaluator => arg => double(evalHelper(expressionEvaluator)(arg)), addInvalidHandling);
    }
    /**
     * !!! Be aware when using this function, it will create different overloads with different return types !!!
     * Arithmetic operators take 2 numeric arguments, and return a single numerical
     * value. The type of the return value is heavily dependent on the types of the
     * input arguments. In JS everything is a double, but in SPARQL it is not.
     *
     * The different arguments are handled by type promotion and subtype substitution.
     * The way numeric function arguments work is described here:
     * https://www.w3.org/TR/xpath20/#mapping
     * Above url is referenced in the sparql spec: https://www.w3.org/TR/sparql11-query/#OperatorMapping
     */
    arithmetic(op, addInvalidHandling = true) {
        const evalHelper = (expressionEvaluator) => (left, right) => op(expressionEvaluator)(left.typedValue, right.typedValue);
        return this.onBinary([Consts_1.TypeURL.XSD_INTEGER, Consts_1.TypeURL.XSD_INTEGER], expressionEvaluator => (left, right) => integer(evalHelper(expressionEvaluator)(left, right)), addInvalidHandling)
            .onBinary([Consts_1.TypeURL.XSD_DECIMAL, Consts_1.TypeURL.XSD_DECIMAL], expressionEvaluator => (left, right) => decimal(evalHelper(expressionEvaluator)(left, right)), addInvalidHandling)
            .onBinary([Consts_1.TypeURL.XSD_FLOAT, Consts_1.TypeURL.XSD_FLOAT], expressionEvaluator => (left, right) => float(evalHelper(expressionEvaluator)(left, right)), addInvalidHandling)
            .onBinary([Consts_1.TypeURL.XSD_DOUBLE, Consts_1.TypeURL.XSD_DOUBLE], expressionEvaluator => (left, right) => double(evalHelper(expressionEvaluator)(left, right)), addInvalidHandling);
    }
    numberTest(test) {
        return this.numeric(expressionEvaluator => ([left, right]) => {
            const result = test(expressionEvaluator)(left.typedValue, right.typedValue);
            return bool(result);
        });
    }
    stringTest(test, addInvalidHandling = true) {
        return this
            .set([C.TypeURL.XSD_STRING, C.TypeURL.XSD_STRING], expressionEvaluator => ([left, right]) => {
            const result = test(expressionEvaluator)(left.typedValue, right.typedValue);
            return bool(result);
        }, addInvalidHandling);
    }
    booleanTest(test, addInvalidHandling = true) {
        return this
            .set([C.TypeURL.XSD_BOOLEAN, C.TypeURL.XSD_BOOLEAN], expressionEvaluator => ([left, right]) => {
            const result = test(expressionEvaluator)(left.typedValue, right.typedValue);
            return bool(result);
        }, addInvalidHandling);
    }
    dateTimeTest(test, addInvalidHandling = true) {
        return this
            .set([C.TypeURL.XSD_DATE_TIME, C.TypeURL.XSD_DATE_TIME], expressionEvaluator => ([left, right]) => {
            const result = test(expressionEvaluator)(left.typedValue, right.typedValue);
            return bool(result);
        }, addInvalidHandling);
    }
    numeric(op) {
        return this.set([C.TypeAlias.SPARQL_NUMERIC, C.TypeAlias.SPARQL_NUMERIC], op);
    }
}
exports.Builder = Builder;
// ----------------------------------------------------------------------------
// Literal Construction helpers
// ----------------------------------------------------------------------------
function bool(val) {
    return new E.BooleanLiteral(val);
}
function integer(num) {
    return new E.IntegerLiteral(num);
}
function decimal(num) {
    return new E.DecimalLiteral(num);
}
function float(num) {
    return new E.FloatLiteral(num);
}
function double(num) {
    return new E.DoubleLiteral(num);
}
function string(str, dataType) {
    return new E.StringLiteral(str, dataType);
}
function langString(str, lang) {
    return new E.LangStringLiteral(str, lang);
}
function dirLangString(str, lang, direction) {
    return new E.DirLangStringLiteral(str, lang, direction);
}
function dateTime(date, str) {
    return new E.DateTimeLiteral(date, str);
}
function expressionToVar(dataFactory, variableExpression) {
    return dataFactory.variable(variableExpression.name.slice(1));
}
//# sourceMappingURL=Helpers.js.map